import React from 'react';

import styles from './SevereErrorSplash.scss';

export interface ISevereErrorSplashProps {
  shouldShow?: boolean;
  data: {
    message: string;
    title: string;
    code: string;
  };
}

export const SevereErrorSplash = (props: ISevereErrorSplashProps) =>
  props.shouldShow && (
    <div className={styles.container}>
      <div className={styles.title}>{props.data.title}</div>
      <div className={styles.message}>{props.data.message}</div>
      <div className={styles.code}>{props.data.code}</div>
    </div>
  );
